import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["items", "template", "empty"]

  connect() {
    this._updateEmpty()
  }

  add() {
    const template = this.templateTarget.content.cloneNode(true)
    this.itemsTarget.appendChild(template)
    this._updateEmpty()
  }

  remove(event) {
    event.currentTarget.closest("[data-business-item]").remove()
    this._updateEmpty()
  }

  _updateEmpty() {
    if (!this.hasEmptyTarget) return
    const hasItems = this.itemsTarget.querySelectorAll("[data-business-item]").length > 0
    this.emptyTarget.classList.toggle("hidden", hasItems)
  }
}
